<template>
    <div class="">
        <h3 class="confirm-card__title">{{ currentStep.title }}</h3>

        <LoadingSpinner v-if="!vehicle" />

        <div v-if="vehicle">
            <img
                class="confirm-card__image--mobile"
                v-if="vehicle.image"
                :src="vehicle.image"
                alt="Car Image"
            />
            <div class="confirm-card__card">
                <div class="confirm-card__inner">
                    <img
                        class="confirm-card__image--desktop"
                        v-if="vehicle.image"
                        :src="vehicle.image"
                        alt="Car Image"
                    />
                    <div class="">
                        <h3 class="confirm-card__heading">
                            {{ vehicle.make + " " + vehicle.model }}
                        </h3>
                        <p class="confirm-card__text">{{ vehicle.derivative }}</p>

                        <button
                            type="button"
                            class="btn btn--primary btn--full-width confirm-card__button"
                            v-on:click="nextPage"
                        >
                            <span class="confirm-card__button-text">Yes, Continue</span>
                        </button>
                        <button
                            type="button"
                            class="confirm-card__link"
                            v-on:click="reject"
                        >
                            Try again
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import LoadingSpinner from "../../../../core/components/LoadingSpinner.vue";
import { customEvent } from "../../../../modules/tracking/AnalyticsEvents";

export default {
    components: {
        LoadingSpinner,
    },
    computed: {
        ...mapState(["vehicle", "navigator"]),
        ...mapGetters(["currentStep"]),
    },
    methods: {
        nextPage() {
            customEvent({
                category: "Clean Air Zone",
                label: "Step {$currentStep.step} of {$currentStep.total}",
                action: "Clicked",
            });
            this.$store.dispatch("navigatorStep", this.currentStep.next);
        },
        reject() {
            this.$store.dispatch("navigatorStep", this.currentStep.previous);
        },
    },
};
</script>

<style lang="scss" scoped>
.confirm-card {
    &__card {
        box-shadow: 0 11px 24px rgba(0, 0, 0, 0.07);
        border-radius: 10px;
        border-top: 10px solid #0293d6;
        margin-left: auto;
        margin-right: auto;
        width: 100%;
        max-width: none;
    }

    @media (min-width: 768px) and (max-width: 991px) {
        &__card {
            max-width: 550px;
            margin-left: auto;
            margin-right: auto;
        }
    }

    &__title {
        font-weight: 700;
        font-size: 20px;
        line-height: 20px;
        color: #192a44;
        margin-top: 38px;
        margin-bottom: 30px;
    }

    &__inner {
        display: grid;
        grid-template-columns: 1fr;
        align-items: center;
        padding: 25px;
        background-color: white;
        border-radius: 0 0 10px 10px;
        height: 100%;
        column-gap: 15px;
    }

    @media (min-width: 992px) {
        &__inner {
            grid-template-columns: repeat(2, 1fr);
        }
    }

    &__image--desktop {
        display: none;
    }

    &__image--mobile {
        display: block;
        max-width: 100%;
    }

    @media (min-width: 768px) {
        &__image--mobile {
            max-width: 550px;
            margin-left: auto;
            margin-right: auto;
        }
    }

    @media (min-width: 992px) {
        &__image--desktop {
            display: block;
            max-width: 100%;
        }

        &__image--mobile {
            display: none;
        }
    }

    &__heading {
        font-weight: 700;
        font-size: 16px;
        line-height: 24px;
        color: #4a4a4a;
    }

    &__text {
        margin: 0;
    }

    &__link {
        appearance: none;
        border: none;
        background: unset;
        width: 100%;
        font-size: 16px;
        color: #0293d6;
        font-weight: 600;
        margin-top: 20px;
        display: block;
        text-decoration: underline;
        text-align: center;
        padding: 0;
        cursor: pointer;
    }

    @media (min-width: 992px) {
        &__link {
            text-align: left;
        }
    }

    &__button {
        margin-top: 25px;
    }

    @media (min-width: 992px) {
        &__button {
            max-width: 295px;
        }
    }

    &__button-text {
        text-transform: none;
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/clean-air-zone/steps/Confirm.vue